import Vue from 'vue'
import router from '@/router'
import Map from '@/components/map.js'
import Dialog from '@/components/inc/modal/dialog.vue'
import store from '@/store'
import {Message} from 'iview'
import axios from '@/libs/http'

export default {

}

export const dialog = {
	Instance:new Vue({
		data:{
			name:'',
			visible:false,
			width:50,
			title:'',
			body:resolve => require(['@/components/inc/component/_404.vue'],resolve),
			params:{}
		},
		router,
		render(h){
			return h(Dialog,{
				props: Object.assign({
					'width':this.width,
					'title':this.title
				}),
				domProps: {
                    value: this.visible
                },
			},[h(this.body,{props:{'params':this.params}})])
		}
	}),
	show(props={}){
		const component = this.Instance.$mount();
		document.body.appendChild(component.$el);
		const modal = this.Instance.$children[0];
		modal.$parent.width = 50;
		if ('name' in props) modal.$parent.name = props.name
		if ('title' in props) modal.$parent.title = props.title
		if ('component' in props) modal.$parent.body = Map.filterMeta(props.component);
		if ('params' in props){
			modal.$parent.params = props.params;
			if (props.params.width) modal.$parent.width = props.params.width;
		}
		modal.visible = true
	},
	finish(props={}){
		if(props.type=="tag") this.Instance.$emit('emitClose',this.Instance.$route,props._PATH);
		if(props.type=="dialog"){
			router.push({path:this.Instance.$route.path,query:{refresh:new Date().getTime()}});
			this.Instance.$children[0].visible = false;
		}
	},
	close(props={}){
		if(props.type=="tag") this.Instance.$emit('emitClose',this.Instance.$route,props._PATH);
		if(props.type=="dialog"){
			this.Instance.$children[0].visible = false;
		}
	},
    // 此方法是通过面包屑数组形式跳转到，比如this.$Dialog.goRoute(['安全监控','故障业务监控']);，
    // 不知道为啥要这样写，为了兼容代码中用到此方法，之前是通过事件触发跳转，
    // 只改为push方法跳转，改后未验证，可能是平台端，所以你不需要太关心
	goRoute(arr,params,doorflag=false){//doorflag门户子系统和资金方子系统
		if(arr[0]&&arr[1]){
			const menuArr = store.state.menu.list;
			const topList = doorflag?menuArr[1].list.find(x => x.title == arr[0]):menuArr[0].list.find(x => x.title == arr[0]);
			const side1List = topList.list.find(x => x.title == arr[1]);
			if(arr[2]){
				const side2List = side1List.list.find(x => x.title == arr[2]);
                router.push({name: side2List.name, params: params || {}})
				// this.Instance.$emit('mysetTopBar',topList);
				// this.Instance.$emit('myturnToPage',{one:side1List,two:side2List,params});
			}else{
                router.push({name: side1List.name, params: params || {}})
				// this.Instance.$emit('mysetTopBar',topList);
				// this.Instance.$emit('myturnToPage',{one:side1List,params});
			}
		}
	},
    // 通过页面路由id获取此页面关联菜单，返回关联菜单的数组，注意：因业务需求不需要三级菜单，所以此方法只支持到遍历二级菜单，暂时这样（待优化）
    getMenuByIdFun (id,doorflag=false) {
        let menuArr = store.state.menu.list
        let idArr = []
        let i = id.lastIndexOf('-')
        var len = id.substr(i + 1).length// -后面的字段长度
        var topid = id.substr(0, i + 4)// 顶部导航栏id
        var side1id = id.substr(0, i + 7)// 侧边一级导航栏id
        let side2id = ''
        if (len > 6) {
            if (len < 10) {
                side2id = id.substr(0, i + len + 1) // 侧边二级导航栏id，但有可能有详情页面，id大于10
            } else {
                side2id = id.substr(0, i + 10)
            }
        }
        // 侧边二级导航栏id
        function forlist (list) {
            list.forEach((item, index) => {
                if (item.id === topid) { idArr.push(item) }
                if (item.id === side1id) { idArr.push(item) }
                if (side2id && (item.id === side2id)) { idArr.push(item) }
                if (item.list)forlist(item.list)
            })
        }
        if(doorflag){//门户子系统
            // 可能只有一个门户子系统菜单
            if(menuArr.length>1){
                forlist(menuArr[1].list);
            }else{
                forlist(menuArr[0].list);
            }
        }else{
        	forlist(menuArr[0].list)
        }
        return idArr
    },
    // 这是老代码中用到很多goRouteByID，兼容之前的代码，保留goRouteById，新页面跳转直接使用$router.push跳转即可
	goRouteById(id,params={},doorflag=false){//doorflag门户子系统true
        router.push({name: id, params: params})
        this.Instance.$emit('clearInc')
	},

	//数组排序
	sortList(list, data){
		//根据向上或者向下箭头进行正序或者倒序排列
		const compare = (upDown, key) => (a, b) => upDown === 'up' ? Number(a[key]) - Number(b[key]) : Number(b[key]) - Number(a[key]);
		return data.type&&data.sortKey ? list.sort(compare(data.type, data.sortKey)) : list;
	}
}
export function getRouterPermission(nameId) {
   let routerPermissionList = store.state.menu.routerPermissionList
   let isHave = routerPermissionList.filter((item)=>{
       return item.name == nameId
   })
    if(isHave.length>0){
        return true
    }else{
        return false
    }
}
export function uuid(len, radix) {
	var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	var uuid = [], i;
	radix = radix || chars.length;

	if (len) {
		for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random()*radix];
	} else {
		var r;
		uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
		uuid[14] = '4';
		for (i = 0; i < 36; i++) {
			if (!uuid[i]) {
				r = 0 | Math.random()*16;
				uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
			}
		}
	}
	return uuid.join('');
}

export function checkRoute(newRoute,name){
	if(newRoute.matched.length){
		let n = newRoute.matched.length-1;
		let nm = newRoute.matched[n].components.default.name;
		if(nm==name) return true;
		return false;
	}
	return false;
}
export function eqObj( x, y ) {
	if ( x === y ) {
		return true;
	}
	if ( ! ( x instanceof Object ) || ! ( y instanceof Object ) ) {
		return false;
	}
	if ( x.constructor !== y.constructor ) {
		return false;
	}

	for ( var p in x ) {
		if ( x.hasOwnProperty( p ) ) {
			if ( ! y.hasOwnProperty( p ) ) {
				return false;
			}
			if ( x[ p ] === y[ p ] ) {
				continue;
			}
			if ( typeof( x[ p ] ) !== "object" ) {
				return false;
			}
			if ( ! Object.equals( x[ p ], y[ p ] ) ) {
				return false;
			}
		}
	}

	for ( p in y ) {
		if ( y.hasOwnProperty( p ) && ! x.hasOwnProperty( p ) ) {
			return false;
		}
	}
	return true;
}
export function floatPoint(one,two,str){
		if(!two)return one;
	    //转化为字符串
	    one = '' + one
	    two = '' + two
	    //切割成整数部分和小数部分
	    var oneStr = one.split('.')
	    var twoStr = two.split('.')

	    // 处理参数一或二为整数的情况
	    if (!oneStr[1]) {
	        oneStr[1] = '0'
	    }
	    if (!twoStr[1]) {
	        twoStr[1] = '0'
	    }

	    var length = null
	    //比较小数部分的长度，以确定剥离小数点后放大的倍数
	    var oneFloatLength = oneStr[1].length
	    var TwoFloatLength = twoStr[1].length
	    if (oneFloatLength > TwoFloatLength) {
	        length = oneFloatLength
	        twoStr[1] = twoStr[1].padEnd(length, '0')
	    } else if (TwoFloatLength > oneFloatLength) {
	        length = TwoFloatLength
	 		oneStr[1] = oneStr[1].padEnd(length, '0')
	    } else {
	        length = TwoFloatLength
	    }
	    // 拼接成处理后的数字
	    var oneBig = (oneStr[0] === '0' ? '' : oneStr[0]) + oneStr[1]
	    var twoBig = (twoStr[0] === '0' ? '' : twoStr[0]) + twoStr[1]

		if(oneBig.length>1&&oneBig<10){oneBig = oneBig.substring(1)}
		if(twoBig.length>1&&twoBig<10){twoBig = twoBig.substring(1)}

	    //根据运算符决定运算后缩小的倍数
	    var result = null
	    switch (str) {
	        case '+':
	            ;
	        case '-':
	            result = eval(oneBig + str + twoBig) / (10 ** length)
	            break;
	        case '*':
	            result = eval(oneBig + str + twoBig) / (10 ** (length * 2))
	            break;
	        case '/':
	            result = eval(oneBig + str + twoBig)
	    }
	    return result
}
export function alertMsg(obj){//obj存放不同业务环节要下面校验哪些项的开关
	let openObj = store.state.user.openObj || null;//openObj是否开通产品、是否签署e诺产品使用协议、是否签署付款承诺函等标识（若是新更新的协议，则需要重新签署）
	if(openObj && typeof(obj) === "object"){
		if(obj.open && !openObj.openFlag){dialog.Instance.$Message.error({content:`请开通产品后再进行此操作`,closable: true,duration:5});return}
		if(obj.agreement && !openObj.agreementFlag){dialog.Instance.$Message.error({content:`请签署金云e诺产品使用协议后再进行此操作`,closable: true,duration:5});return}
		if(obj.pay && !openObj.payFlag){dialog.Instance.$Message.error({content:`请签署付款承诺函后再进行此操作`,closable: true,duration:5});return}
	}else if(obj && typeof(obj) === "string"){
		dialog.Instance.$Message.error({content:`当前操作员与经办操作员为同一人`,closable: true,duration:5});
	}
}
export function banBack() {//禁用浏览器返回
	history.pushState(null, null, document.URL);
	window.addEventListener('popstate', function () {
			history.pushState(null, null, document.URL);
	});
}
// 判断是否是一个数组
export function isObject (obj) {
    return Object.prototype.toString.call(obj) === '[object Object]'
}
// 判断是否是一个空数组
export function isNullObject (obj) {
    return JSON.stringify(obj) === '{}'
}
// 合并两个数组
export function extend (target, source) {
    if (!isObject(source)) {
        return target
    }
    for (let key in source) {
        if (source.hasOwnProperty(key) === true) {
            // 此处hasOwnProperty是判断自有属性，使用 for in 循环遍历对象的属性时，原型链上的所有属性都将被访问会避免原型对象扩展带来的干扰
            target[key] = source[key]
        }
    }
    return target
}
// 上传
export function handleUpload (file, config = {}) {
    // 默认配置
    let defaultConfig = {
        uploadUrl: '', // 上传的url
        exParams: {}, // 上传的参数
        includeFileType: [], // 上传类型
        fileSize: 1024 * 1024 * 100 // 上传文件大小 默认100m
    }
    let merOptions = extend(defaultConfig, config)
    let fileName = file.name.split('.')[file.name.split('.').length - 1].toLowerCase()
    const includeFileType = merOptions.includeFileType.map(e => e.toLowerCase())
    if ((includeFileType.length > 0) && (!includeFileType.includes(fileName))) {
        return Message.error('文件格式不正确，请重新上传！')
    } else if (file.size > merOptions.fileSize) {
        return Message.error('文件大小不能超过100M，请您重新上传！')
    }
    const fd = new FormData()
    fd.append('file', file)
    if (isObject(merOptions.exParams) && (!isNullObject(merOptions.exParams))) {
        for (let x in merOptions.exParams) {
            fd.append(x, merOptions.exParams[x])
        }
    }
    return new Promise((resolve, reject) => {
        axios.postText(merOptions.uploadUrl, fd).then(data => {
            resolve()
        }).catch((err) => { reject(err) })
    })
}
// 下载filename
export function download (config = {}) {
    // 默认配置
    let defaultConfig = {
        ajaxType: 'downloadGet',
        downloadUrl: '/gyl/ec_info/findOrDowanImage', // 下载的url
        exParams: {}, // 下载的参数,
        filename: '' // 下载的名字
    }
    let merOptions = extend(defaultConfig, config)
    axios[merOptions.ajaxType](merOptions.downloadUrl, merOptions.exParams).then(res => {
        let filename = merOptions.filename
        let data = res
        if (merOptions.ajaxType === 'preview'|| merOptions.ajaxType === 'previewPost') {
            if (res.status !== 200 || !res.data) {
                Message.error({content: '下载失败', closable: true})
                return
            }
            data = res.data
            if (res.headers && res.headers['content-disposition']){
                filename = res.headers['content-disposition'].split(';')[1].split('filename=')[1]
            }
        }
        if (!data || data.size === 0 ) {
            Message.error({content: '下载失败', closable: true})
            return
        }
        if ('msSaveOrOpenBlob' in navigator) {
            window.navigator.msSaveOrOpenBlob(new Blob([data]), decodeURI(filename))
        } else {
            let url = window.URL.createObjectURL(new Blob([data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', decodeURI(filename))
            document.body.appendChild(link)
            link.click()
        }
    })
}



// WEBPACK FOOTER //
// ./src/libs/fn.js